import { jsxs, jsx } from 'react/jsx-runtime';
import { RTEText } from '@promo-platform/rte-text';
import { Tooltip } from '@promo-platform/tooltip';
var FieldHead = function FieldHead(_ref) {
  var id = _ref.id,
    label = _ref.label,
    tooltipText = _ref.tooltipText,
    tooltipLabel = _ref.tooltipLabel,
    description = _ref.description;
  return jsxs("div", Object.assign({
    className: "pp-field-head"
  }, {
    children: [jsxs("header", Object.assign({
      className: "pp-field-head__header"
    }, {
      children: [jsx("label", Object.assign({
        className: "pp-field-head__label",
        htmlFor: id
      }, {
        children: label
      })), tooltipText ? jsx(Tooltip, {
        text: tooltipText,
        label: tooltipLabel
      }) : null]
    })), description ? jsx(RTEText, {
      className: "pp-field-head__description",
      text: description
    }) : null]
  }));
};
export { FieldHead };